import { BrowserMCP } from './browser-mcp';

export { BrowserMCP } from './browser-mcp';
export type {
	ModelContext,
	ProvideContextInput,
	RegisterToolOptions,
	ToolContent,
	ToolDescriptor,
	ToolResult
} from './browser-mcp.model';

/**
 * Install the singleton on `window.BrowserMCP` so non-Angular consumers
 * (e.g. the Agent Harness running in the page) can reach the registry without
 * an Angular dependency. Guarded with `in window` so a re-import is a no-op.
 */
if (!('BrowserMCP' in window)) {
	window.BrowserMCP = BrowserMCP.getInstance();
}

declare global {
	interface Window {
		BrowserMCP?: BrowserMCP;
	}
}
